import React from "react";
import "../../assets/scss/generic/radioButton.scss";
import { IListObj } from "../types/genericTypes";

export interface RadioButtonProps {
  list: IListObj; //list of all options in radio btn
  name: string;
  selected?: number | string; // selected value
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
  disabled?: boolean;
  moduleName?:
    | "orderBook"
    | "orderPlacement"
    | "fundTransfer"
    | "subscriptionFrom_radio"; // takes orderBook as default
}

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const moduleName = props.moduleName ? props.moduleName : "orderBook";

  return (
    <label className={"pointer radio_btn " + moduleName}>
      <input
        type="radio"
        value={props.list.value}
        name={props.name}
        key={props.list.value}
        checked={props.selected === props.list.value}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <span className="checkmark"></span>
      <span className="disp_val"> {props.list.display}</span>
    </label>
  );
};

export default RadioButton;
